import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import LeftSection from "./components/LeftSection";
import RightSection from "./components/RightSection";
import Button from "components/BaseWidgets/button";
import { useActivityLog } from "hooks/api/useActivityLog";

function ActivityLog() {
  const [currentPage, setCurrentPage] = useState(1);
  const [isShow, setShow] = useState(false);
  const [allActivities, setAllActivities] = useState({
    activity_today: [],
    activity_earlier: [],
  });
  const [filterData, setFilterData] = useState({
    period: 2,
    type: [0, 8, 7],
  });

  const scrollPositionRef = useRef(0);
  const loadMoreRef = useRef(null);

  const apiFilterData = {
    period: filterData.period,
    ...(filterData.type.length > 0 && { type: filterData.type }),
  };

  const { data, isLoading } = useActivityLog({
    page: currentPage,
    limit: 10,
    filter: JSON.stringify(apiFilterData),
  });

  useEffect(() => {
    if (data?.activity_data) {
      setAllActivities((prev) => ({
        activity_today:
          currentPage === 1
            ? data.activity_data.activity_today || []
            : [
                ...prev.activity_today,
                ...(data.activity_data.activity_today || []),
              ],
        activity_earlier:
          currentPage === 1
            ? data.activity_data.activity_earlier || []
            : [
                ...prev.activity_earlier,
                ...(data.activity_data.activity_earlier || []),
              ],
      }));
    }
  }, [data]);

  const handleFilterChange = (newFilterData) => {
    setFilterData(newFilterData);
    setCurrentPage(1);
    setAllActivities({
      activity_today: [],
      activity_earlier: [],
    });
  };

  useLayoutEffect(() => {
    if (currentPage > 1) {
      window.scrollTo({
        top: scrollPositionRef.current,
        behavior: "auto",
      });
    }
  }, [allActivities]);

  const handleLoadMore = () => {
    if (loadMoreRef.current) {
      scrollPositionRef.current =
        loadMoreRef.current.getBoundingClientRect().top + window.scrollY - 20;
    }
    setCurrentPage((prev) => prev + 1);
  };

  const totalPages = data?.count
    ? Math.ceil(data.count / (data.limit || 10))
    : 0;
  const isMoreData = currentPage < totalPages;

  return (
    <div className="container flex flex-col gap-6 activity-container">
      <div className="flex gap-10 content-wrapper">
        <LeftSection
          isShow={isShow}
          setShow={setShow}
          setFilterData={handleFilterChange}
          filterData={filterData}
        />
        <RightSection
          setShow={setShow}
          setCurrentPage={setCurrentPage}
          data={allActivities}
          isLoading={isLoading && currentPage === 1}
        />
      </div>

      {/* Load More Button */}
      {(allActivities.activity_today.length > 0 ||
        allActivities.activity_earlier.length > 0) && (
        <div className="flex justify-center w-full">
          <Button
            ref={loadMoreRef}
            isDisabled={!isMoreData}
            isLoading={isLoading && currentPage > 1}
            onClick={handleLoadMore}
            height={44}
            className="load-more-btn"
          >
            Load more
          </Button>
        </div>
      )}
    </div>
  );
}

export default ActivityLog;
